export default "__VITE_ASSET__B7fteX48__"